import { ElementRef, EventEmitter, SimpleChanges, TemplateRef } from "@angular/core";
import { ChangeAttributes } from "./change-attributes";
import { ConfirmAttributes } from "./confirm-attributes";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Router } from "@angular/router";
import { SessionService } from "../session.service";
import { User } from '../../../core/user/user.model';
import moment from "moment";
import * as momenttz from 'moment-timezone';
import { DialogAttributes } from "./dialog-attributes";
import { PaymentService } from '../../payment/payment.service';
import { AccountService } from '../../../core/auth/account.service';
import { UserService } from '../../../core/user/user.service';
import { JhiLanguageService } from '../../../ng-jhipster/language';
import { JhiEventManager } from '../../../ng-jhipster/service';
import { SessionStorageService } from "ngx-webstorage";
import { TrackerService } from '../../../core/tracker/tracker.service';
import { PricingService } from '../../pricing/pricing.service';
import { COACH_LABELS, LANGUAGES } from '../../../app.constants';
import { UserVoucherService } from '../../user-voucher/user-voucher.service';
import { BaseComponent } from '../../../shared/base.component';
import { SessionSettingService } from '../../session-setting/session-setting.service';
import { AvailableCoachSlots } from '../../session/schedule-session/available-coach-slots/available-coach-slots.model';
import { AvailableCoachSlotsCalendar } from '../../session/schedule-session/available-coach-slots/available-coach-slots-calendar.model';
import { CalendarEventLinkService } from '../../../core/util/calendar-event-link.service';
import { SessionTypeNotAllowedPopupComponent } from '../../session/schedule-session/session-type-not-allowed-popup/session-type-not-allowed-popup.component';
import * as i0 from "@angular/core";
import * as i1 from "../../../core/user/user.service";
import * as i2 from "../../user-voucher/user-voucher.service";
import * as i3 from "../../pricing/pricing.service";
import * as i4 from "../session.service";
import * as i5 from "../../payment/payment.service";
import * as i6 from "../../../core/auth/account.service";
import * as i7 from "../../session-setting/session-setting.service";
import * as i8 from "@angular/router";
import * as i9 from "../../../ng-jhipster/service";
import * as i10 from "../../../ng-jhipster/language";
import * as i11 from "../../../core/tracker/tracker.service";
import * as i12 from "ngx-webstorage";
import * as i13 from "@ng-bootstrap/ng-bootstrap";
import * as i14 from "../../../core/util/calendar-event-link.service";
import * as i15 from "@angular/common";
import * as i16 from "../../../shared/timezone/timezone-dropdown.component";
import * as i17 from "../../../ng-jhipster/language/jhi-translate.directive";
import * as i18 from "../../payment-selection/payment-selection.component";
import * as i19 from "../../../shared/coach-info/coach-info.component";
import * as i20 from "./available-coach-slots/available-coach-slots-calendar/available-coach-slots-calendar.component";
import * as i21 from "@angular/material/form-field";
import * as i22 from "@angular/material/input";
import * as i23 from "@angular/forms";
import * as i24 from "./session-language-selector/session-language-selector.component";
import * as i25 from "../label-selector/label-selector.component";
import * as i26 from "./coach-profile-image/coach-profile-image.component";
import * as i27 from "./supported-languages/supported-languages.component";
import * as i28 from "../../../shared/badge/badge.component";
import * as i29 from "./coach-reasoning/coach-reasoning.component";
import * as i30 from "../../../shared/stepper-component/stepper.component";
import * as i31 from "./session-scheduled-popup/session-scheduled-popup.component";
import * as i32 from "../../../shared/modal-success/modal-success.component";
import * as i33 from "@fortawesome/angular-fontawesome";
import * as i34 from "../../../shared/alert/alert-error.component";
import * as i35 from "../../../shared/coach-bio/coach-bio.component";
import * as i36 from "@ngx-translate/core";
const _c0 = ["alreadyFutureSessionDialog"];
const _c1 = ["alreadyFutureSessionDialogForCoach"];
const _c2 = ["okDialog"];
const _c3 = ["dialogBox"];
const _c4 = ["paymentCancelledDialogBox"];
const _c5 = ["paymentCannotBeVerifiedDialogBox"];
const _c6 = ["paymentIsBeingProcessedDialogBox"];
const _c7 = ["noCredit"];
const _c8 = ["noCreditForCoach"];
const _c9 = ["coachBioModal"];
function ScheduleSessionComponent_payment_selection_6_Template(rf, ctx) { if (rf & 1) {
    const _r37 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "payment-selection", 38);
    i0.ɵɵlistener("onScheduleSession", function ScheduleSessionComponent_payment_selection_6_Template_payment_selection_onScheduleSession_0_listener($event) { i0.ɵɵrestoreView(_r37); const ctx_r36 = i0.ɵɵnextContext(); return ctx_r36.getScheduledSession($event); })("onMakePayment", function ScheduleSessionComponent_payment_selection_6_Template_payment_selection_onMakePayment_0_listener() { i0.ɵɵrestoreView(_r37); const ctx_r38 = i0.ɵɵnextContext(); return ctx_r38.smoothScrollToElement("make-payment-mobile"); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("selectedUser", ctx_r0.selectedUser)("selectedTimezone", ctx_r0.selectedTimezone)("confirmAttributes", ctx_r0.confirmAttributes)("changeAttributes", ctx_r0.changeAttributes)("videoChatEnabled", ctx_r0.videoChatEnabled)("textChatEnabled", ctx_r0.textChatEnabled)("isCoach", ctx_r0.isCoach)("momentDate", ctx_r0.momentDate)("sessionCreateDTO", ctx_r0.sessionCreateDTO)("isScheduled", ctx_r0.isScheduled)("coachLanguages", ctx_r0.coachLanguages)("textSessionCount", ctx_r0.textSessionCount)("isCoronaUser", ctx_r0.isCoronaUser)("session", ctx_r0.session)("dialogAttributes", ctx_r0.dialogAttributes)("visibleDialogBox", ctx_r0.visibleDialogBox)("pricingList", ctx_r0.pricingList)("userSessionCount", ctx_r0.userSessionCount)("sessionType", ctx_r0.sessionType)("sessionId", ctx_r0.sessionId);
} }
function ScheduleSessionComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵelement(1, "coach-info", 39);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r1.notEmbedded() ? "card card-borderless" : "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("coachId", ctx_r1.currentCoach.id)("selectedSessionType", ctx_r1.sessionType);
} }
const _c10 = function (a0) { return { year: a0 }; };
function ScheduleSessionComponent_div_9_h3_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "h3", 49);
} if (rf & 2) {
    const ctx_r39 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate1("jhiTranslate", "sessionSchedule.header.months.", (ctx_r39.selectedDayAvailableCoachSlots == null ? null : ctx_r39.selectedDayAvailableCoachSlots.day.month()) + 1, "");
    i0.ɵɵproperty("translateValues", i0.ɵɵpureFunction1(2, _c10, ctx_r39.selectedDayAvailableCoachSlots == null ? null : ctx_r39.selectedDayAvailableCoachSlots.day.year()));
} }
function ScheduleSessionComponent_div_9_available_coach_slots_calendar_10_Template(rf, ctx) { if (rf & 1) {
    const _r42 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "available-coach-slots-calendar", 50);
    i0.ɵɵlistener("selectedDateChange", function ScheduleSessionComponent_div_9_available_coach_slots_calendar_10_Template_available_coach_slots_calendar_selectedDateChange_0_listener($event) { i0.ɵɵrestoreView(_r42); const ctx_r41 = i0.ɵɵnextContext(2); return ctx_r41.onSelectedDayChange($event); })("showNextPeriod", function ScheduleSessionComponent_div_9_available_coach_slots_calendar_10_Template_available_coach_slots_calendar_showNextPeriod_0_listener() { i0.ɵɵrestoreView(_r42); const ctx_r43 = i0.ɵɵnextContext(2); return ctx_r43.showNextPeriod(); })("showPreviousPeriod", function ScheduleSessionComponent_div_9_available_coach_slots_calendar_10_Template_available_coach_slots_calendar_showPreviousPeriod_0_listener() { i0.ɵɵrestoreView(_r42); const ctx_r44 = i0.ɵɵnextContext(2); return ctx_r44.showPreviousPeriod(); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r40 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("availableCoachSlotsCalendar", ctx_r40.availableCoachSlotsCalendar)("viewMode", ctx_r40.viewMode);
} }
function ScheduleSessionComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r46 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵelementStart(1, "div", 3);
    i0.ɵɵelementStart(2, "div", 40);
    i0.ɵɵelementStart(3, "div", 41);
    i0.ɵɵtemplate(4, ScheduleSessionComponent_div_9_h3_4_Template, 1, 4, "h3", 42);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 43);
    i0.ɵɵelementStart(6, "button", 44);
    i0.ɵɵlistener("click", function ScheduleSessionComponent_div_9_Template_button_click_6_listener() { i0.ɵɵrestoreView(_r46); const ctx_r45 = i0.ɵɵnextContext(); return ctx_r45.changeViewMode("weekly"); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "button", 45);
    i0.ɵɵlistener("click", function ScheduleSessionComponent_div_9_Template_button_click_7_listener() { i0.ɵɵrestoreView(_r46); const ctx_r47 = i0.ɵɵnextContext(); return ctx_r47.changeViewMode("monthly"); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 46);
    i0.ɵɵelementStart(9, "div", 47);
    i0.ɵɵtemplate(10, ScheduleSessionComponent_div_9_available_coach_slots_calendar_10_Template, 1, 2, "available-coach-slots-calendar", 48);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r2.notEmbedded() ? "card card-borderless" : "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", ctx_r2.notEmbedded() ? "card-body" : "");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r2.selectedDayAvailableCoachSlots);
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("view-mode-switch-selected", ctx_r2.viewMode === "weekly");
    i0.ɵɵadvance(1);
    i0.ɵɵclassProp("view-mode-switch-selected", ctx_r2.viewMode === "monthly");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r2.availableCoachSlotsCalendar);
} }
function ScheduleSessionComponent_div_10_h3_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "h3", 59);
} }
function ScheduleSessionComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r50 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵelementStart(1, "div", 3);
    i0.ɵɵelementStart(2, "div", 51);
    i0.ɵɵtemplate(3, ScheduleSessionComponent_div_10_h3_3_Template, 1, 0, "h3", 52);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 53);
    i0.ɵɵelementStart(5, "div", 54);
    i0.ɵɵelementStart(6, "mat-form-field", 55);
    i0.ɵɵelementStart(7, "mat-label");
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "input", 56);
    i0.ɵɵlistener("ngModelChange", function ScheduleSessionComponent_div_10_Template_input_ngModelChange_10_listener($event) { i0.ɵɵrestoreView(_r50); const ctx_r49 = i0.ɵɵnextContext(); return ctx_r49.searchText = $event; })("focusout", function ScheduleSessionComponent_div_10_Template_input_focusout_10_listener() { i0.ɵɵrestoreView(_r50); const ctx_r51 = i0.ɵɵnextContext(); return ctx_r51.onFocusOut(); })("keyup", function ScheduleSessionComponent_div_10_Template_input_keyup_10_listener($event) { i0.ɵɵrestoreView(_r50); const ctx_r52 = i0.ɵɵnextContext(); return ctx_r52.onKeyUp($event); });
    i0.ɵɵpipe(11, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 54);
    i0.ɵɵelementStart(13, "session-language-selector", 57);
    i0.ɵɵlistener("onChange", function ScheduleSessionComponent_div_10_Template_session_language_selector_onChange_13_listener($event) { i0.ɵɵrestoreView(_r50); const ctx_r53 = i0.ɵɵnextContext(); return ctx_r53.onSelectedSessionLanguagesChanged($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 54);
    i0.ɵɵelementStart(15, "label-selector", 58);
    i0.ɵɵlistener("onLabelsSelected", function ScheduleSessionComponent_div_10_Template_label_selector_onLabelsSelected_15_listener($event) { i0.ɵɵrestoreView(_r50); const ctx_r54 = i0.ɵɵnextContext(); return ctx_r54.onLabelsSelected($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r3.notEmbedded() ? "card card-borderless" : "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", ctx_r3.notEmbedded() ? "card-body" : "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r3.selectedDayAvailableCoachSlots);
    i0.ɵɵadvance(1);
    i0.ɵɵclassProp("d-none", ctx_r3.currentCoach);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(9, 12, "coachManagement.search"));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(11, 14, "coachManagement.search"));
    i0.ɵɵproperty("ngModel", ctx_r3.searchText);
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("d-none", ctx_r3.currentCoach);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("selectedLanguages", ctx_r3.selectedSessionLanguages);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("selectedLabels", ctx_r3.selectedLabels);
} }
function ScheduleSessionComponent_ng_container_16_ng_container_1__svg_svg_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 65);
    i0.ɵɵelement(1, "use", 66);
    i0.ɵɵelementEnd();
} }
function ScheduleSessionComponent_ng_container_16_ng_container_1__svg_svg_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 65);
    i0.ɵɵelement(1, "use", 67);
    i0.ɵɵelementEnd();
} }
const _c11 = function (a0) { return { value: a0 }; };
function ScheduleSessionComponent_ng_container_16_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r60 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 61);
    i0.ɵɵlistener("click", function ScheduleSessionComponent_ng_container_16_ng_container_1_Template_div_click_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r60); const allowedDuration_r56 = restoredCtx.$implicit; const ctx_r59 = i0.ɵɵnextContext(2); return ctx_r59.switchSessionTypeTab("text", allowedDuration_r56); });
    i0.ɵɵelementStart(2, "div");
    i0.ɵɵtemplate(3, ScheduleSessionComponent_ng_container_16_ng_container_1__svg_svg_3_Template, 2, 0, "svg", 62);
    i0.ɵɵtemplate(4, ScheduleSessionComponent_ng_container_16_ng_container_1__svg_svg_4_Template, 2, 0, "svg", 62);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "h5", 63);
    i0.ɵɵelementStart(6, "div");
    i0.ɵɵtext(7, " \u00A0(");
    i0.ɵɵelement(8, "span", 64);
    i0.ɵɵtext(9, ") ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const allowedDuration_r56 = ctx.$implicit;
    const ctx_r55 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵclassProp("selected-tab", ctx_r55.sessionTypeTab === "text" && ctx_r55.duration == allowedDuration_r56);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r55.sessionTypeTab === "text" && ctx_r55.duration == allowedDuration_r56);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r55.sessionTypeTab !== "text" || ctx_r55.duration != allowedDuration_r56);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("translateValues", i0.ɵɵpureFunction1(5, _c11, allowedDuration_r56));
} }
function ScheduleSessionComponent_ng_container_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ScheduleSessionComponent_ng_container_16_ng_container_1_Template, 10, 7, "ng-container", 60);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r4.sessionDurationByType.text);
} }
function ScheduleSessionComponent_ng_container_17_ng_container_1__svg_svg_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 70);
    i0.ɵɵelement(1, "use", 71);
    i0.ɵɵelementEnd();
} }
function ScheduleSessionComponent_ng_container_17_ng_container_1__svg_svg_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 70);
    i0.ɵɵelement(1, "use", 72);
    i0.ɵɵelementEnd();
} }
function ScheduleSessionComponent_ng_container_17_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r66 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 61);
    i0.ɵɵlistener("click", function ScheduleSessionComponent_ng_container_17_ng_container_1_Template_div_click_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r66); const allowedDuration_r62 = restoredCtx.$implicit; const ctx_r65 = i0.ɵɵnextContext(2); return ctx_r65.switchSessionTypeTab("video", allowedDuration_r62); });
    i0.ɵɵelementStart(2, "div");
    i0.ɵɵtemplate(3, ScheduleSessionComponent_ng_container_17_ng_container_1__svg_svg_3_Template, 2, 0, "svg", 68);
    i0.ɵɵtemplate(4, ScheduleSessionComponent_ng_container_17_ng_container_1__svg_svg_4_Template, 2, 0, "svg", 68);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "h5", 69);
    i0.ɵɵelementStart(6, "div");
    i0.ɵɵtext(7, " \u00A0(");
    i0.ɵɵelement(8, "span", 64);
    i0.ɵɵtext(9, ") ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const allowedDuration_r62 = ctx.$implicit;
    const ctx_r61 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵclassProp("selected-tab", ctx_r61.sessionTypeTab === "video" && ctx_r61.duration == allowedDuration_r62);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r61.sessionTypeTab === "video" && ctx_r61.duration == allowedDuration_r62);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r61.sessionTypeTab !== "video" || ctx_r61.duration != allowedDuration_r62);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("translateValues", i0.ɵɵpureFunction1(5, _c11, allowedDuration_r62));
} }
function ScheduleSessionComponent_ng_container_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ScheduleSessionComponent_ng_container_17_ng_container_1_Template, 10, 7, "ng-container", 60);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r5.sessionDurationByType.video);
} }
function ScheduleSessionComponent_ng_container_21_div_1_div_1_div_1_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "badge-component", 90);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const slotPerCoach_r68 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("coachDetails", slotPerCoach_r68.coachDetails);
} }
function ScheduleSessionComponent_ng_container_21_div_1_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r79 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 79);
    i0.ɵɵelementStart(1, "div", 80);
    i0.ɵɵlistener("click", function ScheduleSessionComponent_ng_container_21_div_1_div_1_div_1_Template_div_click_1_listener() { i0.ɵɵrestoreView(_r79); const slotPerCoach_r68 = i0.ɵɵnextContext(2).$implicit; const ctx_r77 = i0.ɵɵnextContext(2); return ctx_r77.displayCoachBio(slotPerCoach_r68.coach); });
    i0.ɵɵelement(2, "coach-profile-image", 81);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 82);
    i0.ɵɵelementStart(4, "div", 83);
    i0.ɵɵlistener("click", function ScheduleSessionComponent_ng_container_21_div_1_div_1_div_1_Template_div_click_4_listener() { i0.ɵɵrestoreView(_r79); const slotPerCoach_r68 = i0.ɵɵnextContext(2).$implicit; const ctx_r80 = i0.ɵɵnextContext(2); return ctx_r80.displayCoachBio(slotPerCoach_r68.coach); });
    i0.ɵɵelementStart(5, "div", 84);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, ScheduleSessionComponent_ng_container_21_div_1_div_1_div_1_div_7_Template, 2, 1, "div", 12);
    i0.ɵɵelementStart(8, "div", 85);
    i0.ɵɵlistener("click", function ScheduleSessionComponent_ng_container_21_div_1_div_1_div_1_Template_div_click_8_listener() { i0.ɵɵrestoreView(_r79); const slotPerCoach_r68 = i0.ɵɵnextContext(2).$implicit; const ctx_r82 = i0.ɵɵnextContext(2); return ctx_r82.displayCoachBio(slotPerCoach_r68.coach); });
    i0.ɵɵelementStart(9, "div");
    i0.ɵɵelementStart(10, "ngb-rating", 86);
    i0.ɵɵlistener("rateChange", function ScheduleSessionComponent_ng_container_21_div_1_div_1_div_1_Template_ngb_rating_rateChange_10_listener($event) { i0.ɵɵrestoreView(_r79); const slotPerCoach_r68 = i0.ɵɵnextContext(2).$implicit; return slotPerCoach_r68.coach.coachScore = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "span", 87);
    i0.ɵɵelementStart(12, "u");
    i0.ɵɵtext(13);
    i0.ɵɵpipe(14, "number");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "div", 88);
    i0.ɵɵlistener("click", function ScheduleSessionComponent_ng_container_21_div_1_div_1_div_1_Template_div_click_15_listener() { i0.ɵɵrestoreView(_r79); const slotPerCoach_r68 = i0.ɵɵnextContext(2).$implicit; const ctx_r86 = i0.ɵɵnextContext(2); return ctx_r86.displayCoachBio(slotPerCoach_r68.coach); });
    i0.ɵɵelement(16, "supported-languages", 89);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const slotPerCoach_r68 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r71 = i0.ɵɵnextContext(2);
    const _r32 = i0.ɵɵreference(56);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("coachLogin", slotPerCoach_r68 == null ? null : slotPerCoach_r68.coach == null ? null : slotPerCoach_r68.coach.login)("coachDetails", slotPerCoach_r68.coachDetails);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(slotPerCoach_r68.coach.login);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", slotPerCoach_r68.coachDetails);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("rate", slotPerCoach_r68.coach.coachScore)("starTemplate", _r32)("readonly", true);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(14, 9, slotPerCoach_r68.coach.coachScore, "1.0-1"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("list", ctx_r71.getSupportedLanguages(slotPerCoach_r68));
} }
function ScheduleSessionComponent_ng_container_21_div_1_div_1_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 46);
    i0.ɵɵelementStart(1, "div", 91);
    i0.ɵɵelement(2, "coach-reasoning", 92);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const slotPerCoach_r68 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("coachReasoningByLang", slotPerCoach_r68.coachReasoningByLang);
} }
const _c12 = function (a0) { return { backgroundColor: a0 }; };
function ScheduleSessionComponent_ng_container_21_div_1_div_1_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r93 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 93);
    i0.ɵɵelementStart(1, "button", 94);
    i0.ɵɵlistener("click", function ScheduleSessionComponent_ng_container_21_div_1_div_1_div_4_Template_button_click_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r93); const date_r90 = restoredCtx.$implicit; const slotIndex_r91 = restoredCtx.index; const ctx_r94 = i0.ɵɵnextContext(2); const slotPerCoach_r68 = ctx_r94.$implicit; const coachIndex_r69 = ctx_r94.index; const ctx_r92 = i0.ɵɵnextContext(2); return ctx_r92.selectHour(ctx_r92.hourOfDate(date_r90), slotPerCoach_r68, coachIndex_r69, slotIndex_r91, 2, date_r90); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const date_r90 = ctx.$implicit;
    const slotIndex_r91 = ctx.index;
    const coachIndex_r69 = i0.ɵɵnextContext(2).index;
    const ctx_r73 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", ctx_r73.isSlotSelected(coachIndex_r69, slotIndex_r91) ? "hour-number hour-number-selected" : "hour-number")("disabled", ctx_r73.futureSessionExists || (ctx_r73.credit == null ? null : ctx_r73.credit.message) != null && (ctx_r73.credit == null ? null : ctx_r73.credit.message) === "noCreditForCoach")("ngStyle", i0.ɵɵpureFunction1(4, _c12, ctx_r73.setHourBackground(coachIndex_r69, slotIndex_r91)));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r73.hourOfDate(date_r90), " ");
} }
function ScheduleSessionComponent_ng_container_21_div_1_div_1_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "hr", 95);
    i0.ɵɵelementEnd();
} }
function ScheduleSessionComponent_ng_container_21_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, ScheduleSessionComponent_ng_container_21_div_1_div_1_div_1_Template, 17, 12, "div", 75);
    i0.ɵɵtemplate(2, ScheduleSessionComponent_ng_container_21_div_1_div_1_div_2_Template, 3, 1, "div", 76);
    i0.ɵɵelementStart(3, "div", 77);
    i0.ɵɵtemplate(4, ScheduleSessionComponent_ng_container_21_div_1_div_1_div_4_Template, 3, 6, "div", 78);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, ScheduleSessionComponent_ng_container_21_div_1_div_1_div_5_Template, 2, 0, "div", 12);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r96 = i0.ɵɵnextContext();
    const slotPerCoach_r68 = ctx_r96.$implicit;
    const coachIndex_r69 = ctx_r96.index;
    const ctx_r70 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r70.currentCoach);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r70.currentCoach);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("id", "coach-available-hours-" + slotPerCoach_r68.coach.login);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", slotPerCoach_r68.sessionStartTimes);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", coachIndex_r69 != ctx_r70.selectedDayAvailableCoachSlots.coachesSlots.length - 1);
} }
function ScheduleSessionComponent_ng_container_21_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 74);
    i0.ɵɵtemplate(1, ScheduleSessionComponent_ng_container_21_div_1_div_1_Template, 6, 5, "div", 12);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const slotPerCoach_r68 = ctx.$implicit;
    i0.ɵɵpropertyInterpolate("id", "coach-card-body-" + slotPerCoach_r68.coach.login);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", slotPerCoach_r68.sessionStartTimes.length > 0);
} }
function ScheduleSessionComponent_ng_container_21_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ScheduleSessionComponent_ng_container_21_div_1_Template, 2, 2, "div", 73);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r6.selectedDayAvailableCoachSlots.coachesSlots);
} }
function ScheduleSessionComponent_div_23_ng_container_1_ng_container_1__svg_svg_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 65);
    i0.ɵɵelement(1, "use", 66);
    i0.ɵɵelementEnd();
} }
function ScheduleSessionComponent_div_23_ng_container_1_ng_container_1__svg_svg_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 65);
    i0.ɵɵelement(1, "use", 67);
    i0.ɵɵelementEnd();
} }
function ScheduleSessionComponent_div_23_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r104 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 96);
    i0.ɵɵlistener("click", function ScheduleSessionComponent_div_23_ng_container_1_ng_container_1_Template_div_click_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r104); const allowedDuration_r100 = restoredCtx.$implicit; const ctx_r103 = i0.ɵɵnextContext(3); return ctx_r103.switchSessionTypeTab("text", allowedDuration_r100); });
    i0.ɵɵelementStart(2, "div", 97);
    i0.ɵɵelementStart(3, "div", 98);
    i0.ɵɵtemplate(4, ScheduleSessionComponent_div_23_ng_container_1_ng_container_1__svg_svg_4_Template, 2, 0, "svg", 62);
    i0.ɵɵtemplate(5, ScheduleSessionComponent_div_23_ng_container_1_ng_container_1__svg_svg_5_Template, 2, 0, "svg", 62);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "h5", 63);
    i0.ɵɵelementStart(7, "div");
    i0.ɵɵtext(8, " \u00A0(");
    i0.ɵɵelement(9, "span", 64);
    i0.ɵɵtext(10, ") ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const allowedDuration_r100 = ctx.$implicit;
    const ctx_r99 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵclassProp("selected-tab", ctx_r99.sessionTypeTab === "text" && ctx_r99.duration == allowedDuration_r100);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r99.sessionTypeTab === "text" && ctx_r99.duration == allowedDuration_r100);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r99.sessionTypeTab !== "text" || ctx_r99.duration != allowedDuration_r100);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("translateValues", i0.ɵɵpureFunction1(5, _c11, allowedDuration_r100));
} }
function ScheduleSessionComponent_div_23_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ScheduleSessionComponent_div_23_ng_container_1_ng_container_1_Template, 11, 7, "ng-container", 60);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r97 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r97.sessionDurationByType.text);
} }
function ScheduleSessionComponent_div_23_ng_container_2_ng_container_1__svg_svg_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 70);
    i0.ɵɵelement(1, "use", 71);
    i0.ɵɵelementEnd();
} }
function ScheduleSessionComponent_div_23_ng_container_2_ng_container_1__svg_svg_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 70);
    i0.ɵɵelement(1, "use", 72);
    i0.ɵɵelementEnd();
} }
function ScheduleSessionComponent_div_23_ng_container_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r110 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 96);
    i0.ɵɵlistener("click", function ScheduleSessionComponent_div_23_ng_container_2_ng_container_1_Template_div_click_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r110); const allowedDuration_r106 = restoredCtx.$implicit; const ctx_r109 = i0.ɵɵnextContext(3); return ctx_r109.switchSessionTypeTab("video", allowedDuration_r106); });
    i0.ɵɵelementStart(2, "div", 97);
    i0.ɵɵelementStart(3, "div", 98);
    i0.ɵɵtemplate(4, ScheduleSessionComponent_div_23_ng_container_2_ng_container_1__svg_svg_4_Template, 2, 0, "svg", 68);
    i0.ɵɵtemplate(5, ScheduleSessionComponent_div_23_ng_container_2_ng_container_1__svg_svg_5_Template, 2, 0, "svg", 68);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "h5", 69);
    i0.ɵɵelementStart(7, "div");
    i0.ɵɵtext(8, " \u00A0(");
    i0.ɵɵelement(9, "span", 64);
    i0.ɵɵtext(10, ") ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const allowedDuration_r106 = ctx.$implicit;
    const ctx_r105 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵclassProp("selected-tab", ctx_r105.sessionTypeTab === "video" && ctx_r105.duration == allowedDuration_r106);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r105.sessionTypeTab === "video" && ctx_r105.duration == allowedDuration_r106);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r105.sessionTypeTab !== "video" || ctx_r105.duration != allowedDuration_r106);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("translateValues", i0.ɵɵpureFunction1(5, _c11, allowedDuration_r106));
} }
function ScheduleSessionComponent_div_23_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ScheduleSessionComponent_div_23_ng_container_2_ng_container_1_Template, 11, 7, "ng-container", 60);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r98 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r98.sessionDurationByType.video);
} }
function ScheduleSessionComponent_div_23_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵtemplate(1, ScheduleSessionComponent_div_23_ng_container_1_Template, 2, 1, "ng-container", 12);
    i0.ɵɵtemplate(2, ScheduleSessionComponent_div_23_ng_container_2_Template, 2, 1, "ng-container", 12);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r7.sessionDurationByType == null ? null : ctx_r7.sessionDurationByType.text);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r7.sessionDurationByType == null ? null : ctx_r7.sessionDurationByType.video);
} }
function ScheduleSessionComponent_ng_container_31_div_1_div_1_div_1_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "badge-component", 90);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const slotPerCoach_r112 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("coachDetails", slotPerCoach_r112.coachDetails);
} }
function ScheduleSessionComponent_ng_container_31_div_1_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r122 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 105);
    i0.ɵɵlistener("click", function ScheduleSessionComponent_ng_container_31_div_1_div_1_div_1_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r122); const slotPerCoach_r112 = i0.ɵɵnextContext(2).$implicit; const ctx_r120 = i0.ɵɵnextContext(2); return ctx_r120.displayCoachBio(slotPerCoach_r112.coach); });
    i0.ɵɵelementStart(1, "div", 106);
    i0.ɵɵelementStart(2, "div", 107);
    i0.ɵɵelement(3, "coach-profile-image", 81);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 108);
    i0.ɵɵelementStart(5, "div", 109);
    i0.ɵɵelementStart(6, "div", 110);
    i0.ɵɵelementStart(7, "div", 111);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, ScheduleSessionComponent_ng_container_31_div_1_div_1_div_1_div_9_Template, 2, 1, "div", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 112);
    i0.ɵɵelementStart(11, "ngb-rating", 86);
    i0.ɵɵlistener("rateChange", function ScheduleSessionComponent_ng_container_31_div_1_div_1_div_1_Template_ngb_rating_rateChange_11_listener($event) { i0.ɵɵrestoreView(_r122); const slotPerCoach_r112 = i0.ɵɵnextContext(2).$implicit; return slotPerCoach_r112.coach.coachScore = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "span", 87);
    i0.ɵɵelementStart(13, "u");
    i0.ɵɵtext(14);
    i0.ɵɵpipe(15, "number");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "div", 113);
    i0.ɵɵelementStart(17, "div", 114);
    i0.ɵɵelement(18, "supported-languages", 89);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "div", 115);
    i0.ɵɵelementStart(20, "div", 91);
    i0.ɵɵelement(21, "coach-reasoning", 92);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const slotPerCoach_r112 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r115 = i0.ɵɵnextContext(2);
    const _r32 = i0.ɵɵreference(56);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("coachLogin", slotPerCoach_r112 == null ? null : slotPerCoach_r112.coach == null ? null : slotPerCoach_r112.coach.login)("coachDetails", slotPerCoach_r112.coachDetails);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", slotPerCoach_r112.coach.login, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", slotPerCoach_r112.coachDetails);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("rate", slotPerCoach_r112.coach.coachScore)("starTemplate", _r32)("readonly", true);
    i0.ɵɵadvance(1);
    i0.ɵɵclassProp("float-right", (slotPerCoach_r112 == null ? null : slotPerCoach_r112.coach == null ? null : slotPerCoach_r112.coach.login == null ? null : slotPerCoach_r112.coach.login.length) <= 16);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(15, 12, slotPerCoach_r112.coach.coachScore, "1.0-1"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("list", ctx_r115.getSupportedLanguages(slotPerCoach_r112));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("coachReasoningByLang", slotPerCoach_r112.coachReasoningByLang);
} }
function ScheduleSessionComponent_ng_container_31_div_1_div_1_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r129 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 116);
    i0.ɵɵelementStart(1, "button", 117);
    i0.ɵɵlistener("click", function ScheduleSessionComponent_ng_container_31_div_1_div_1_div_4_Template_button_click_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r129); const date_r126 = restoredCtx.$implicit; const slotIndex_r127 = restoredCtx.index; const ctx_r130 = i0.ɵɵnextContext(2); const slotPerCoach_r112 = ctx_r130.$implicit; const coachIndex_r113 = ctx_r130.index; const ctx_r128 = i0.ɵɵnextContext(2); return ctx_r128.selectHour(ctx_r128.hourOfDate(date_r126), slotPerCoach_r112, coachIndex_r113, slotIndex_r127, 1, date_r126); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const date_r126 = ctx.$implicit;
    const slotIndex_r127 = ctx.index;
    const coachIndex_r113 = i0.ɵɵnextContext(2).index;
    const ctx_r116 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", ctx_r116.currentCoach ? "col-2" : "col-4");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", ctx_r116.isSlotSelected(coachIndex_r113, slotIndex_r127) ? "hour-number hour-number-selected" : "hour-number")("disabled", ctx_r116.futureSessionExists || (ctx_r116.credit == null ? null : ctx_r116.credit.message) != null && (ctx_r116.credit == null ? null : ctx_r116.credit.message) === "noCreditForCoach")("ngStyle", i0.ɵɵpureFunction1(5, _c12, ctx_r116.setHourBackground(coachIndex_r113, slotIndex_r127)));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r116.hourOfDate(date_r126), "");
} }
function ScheduleSessionComponent_ng_container_31_div_1_div_1_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 114);
    i0.ɵɵelement(1, "hr", 95);
    i0.ɵɵelementEnd();
} }
function ScheduleSessionComponent_ng_container_31_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 100);
    i0.ɵɵtemplate(1, ScheduleSessionComponent_ng_container_31_div_1_div_1_div_1_Template, 22, 15, "div", 101);
    i0.ɵɵelementStart(2, "div", 3);
    i0.ɵɵelementStart(3, "div", 102);
    i0.ɵɵtemplate(4, ScheduleSessionComponent_ng_container_31_div_1_div_1_div_4_Template, 3, 7, "div", 103);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, ScheduleSessionComponent_ng_container_31_div_1_div_1_div_5_Template, 2, 0, "div", 104);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r132 = i0.ɵɵnextContext();
    const slotPerCoach_r112 = ctx_r132.$implicit;
    const coachIndex_r113 = ctx_r132.index;
    const ctx_r114 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r114.currentCoach);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", ctx_r114.currentCoach ? "w-100" : "col-5 offset-1");
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("id", "coach-available-hours-" + slotPerCoach_r112.coach.login);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", slotPerCoach_r112.sessionStartTimes);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", coachIndex_r113 != ctx_r114.selectedDayAvailableCoachSlots.coachesSlots.length - 1);
} }
function ScheduleSessionComponent_ng_container_31_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 74);
    i0.ɵɵtemplate(1, ScheduleSessionComponent_ng_container_31_div_1_div_1_Template, 6, 5, "div", 99);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const slotPerCoach_r112 = ctx.$implicit;
    i0.ɵɵpropertyInterpolate("id", "coach-card-body-" + slotPerCoach_r112.coach.login);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", slotPerCoach_r112.sessionStartTimes.length > 0);
} }
function ScheduleSessionComponent_ng_container_31_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ScheduleSessionComponent_ng_container_31_div_1_Template, 2, 2, "div", 73);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r8.selectedDayAvailableCoachSlots.coachesSlots);
} }
function ScheduleSessionComponent_div_32_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r136 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "h3", 119);
    i0.ɵɵelement(2, "p", 120);
    i0.ɵɵelementStart(3, "button", 121);
    i0.ɵɵlistener("click", function ScheduleSessionComponent_div_32_ng_container_1_Template_button_click_3_listener() { i0.ɵɵrestoreView(_r136); const ctx_r135 = i0.ɵɵnextContext(2); return ctx_r135.extendAutoLookupTries(); });
    i0.ɵɵtext(4, "Extend Search");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} }
function ScheduleSessionComponent_div_32_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r138 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "h3", 122);
    i0.ɵɵelement(2, "p", 123);
    i0.ɵɵelementStart(3, "button", 124);
    i0.ɵɵlistener("click", function ScheduleSessionComponent_div_32_ng_container_2_Template_button_click_3_listener() { i0.ɵɵrestoreView(_r138); const ctx_r137 = i0.ɵɵnextContext(2); return ctx_r137.clearFilters(); });
    i0.ɵɵtext(4, "Clear filters");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} }
function ScheduleSessionComponent_div_32_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 118);
    i0.ɵɵtemplate(1, ScheduleSessionComponent_div_32_ng_container_1_Template, 5, 0, "ng-container", 12);
    i0.ɵɵtemplate(2, ScheduleSessionComponent_div_32_ng_container_2_Template, 5, 0, "ng-container", 12);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r9.autoLookupTries < ctx_r9.maxAutoLookupTriesExtension);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r9.autoLookupTries == ctx_r9.maxAutoLookupTriesExtension);
} }
function ScheduleSessionComponent_div_33_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 125);
} }
function ScheduleSessionComponent_div_34_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 126);
} }
function ScheduleSessionComponent_div_35_Template(rf, ctx) { if (rf & 1) {
    const _r140 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 127);
    i0.ɵɵelementStart(1, "button", 128);
    i0.ɵɵlistener("click", function ScheduleSessionComponent_div_35_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r140); const ctx_r139 = i0.ɵɵnextContext(); return ctx_r139.showAllCoaches(); });
    i0.ɵɵtext(2, "Find other coaches");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
const _c13 = function (a0, a1, a2, a3) { return [a0, a1, a2, a3]; };
function ScheduleSessionComponent_div_36_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 134);
    i0.ɵɵelementStart(1, "div", 135);
    i0.ɵɵelement(2, "h3", 136);
    i0.ɵɵelement(3, "stepper-component", 137);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("items", i0.ɵɵpureFunction4(9, _c13, i0.ɵɵpipeBind1(4, 1, "sessionSchedule.paragraph.howToBookSteps.step1"), i0.ɵɵpipeBind1(5, 3, "sessionSchedule.paragraph.howToBookSteps.step2"), i0.ɵɵpipeBind1(6, 5, "sessionSchedule.paragraph.howToBookSteps.step3"), i0.ɵɵpipeBind1(7, 7, "sessionSchedule.paragraph.howToBookSteps.step4")));
} }
function ScheduleSessionComponent_div_36_payment_selection_3_Template(rf, ctx) { if (rf & 1) {
    const _r144 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "payment-selection", 138);
    i0.ɵɵlistener("onScheduleSession", function ScheduleSessionComponent_div_36_payment_selection_3_Template_payment_selection_onScheduleSession_0_listener($event) { i0.ɵɵrestoreView(_r144); const ctx_r143 = i0.ɵɵnextContext(2); return ctx_r143.getScheduledSession($event); })("onMakePayment", function ScheduleSessionComponent_div_36_payment_selection_3_Template_payment_selection_onMakePayment_0_listener() { i0.ɵɵrestoreView(_r144); const ctx_r145 = i0.ɵɵnextContext(2); return ctx_r145.smoothScrollToElement("make-payment-pc"); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r142 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("selectedUser", ctx_r142.selectedUser)("confirmAttributes", ctx_r142.confirmAttributes)("selectedTimezone", ctx_r142.selectedTimezone)("changeAttributes", ctx_r142.changeAttributes)("sessionCreateDTO", ctx_r142.sessionCreateDTO)("videoChatEnabled", ctx_r142.videoChatEnabled)("textChatEnabled", ctx_r142.textChatEnabled)("isCoach", ctx_r142.isCoach)("momentDate", ctx_r142.momentDate)("isScheduled", ctx_r142.isScheduled)("dialogAttributes", ctx_r142.dialogAttributes)("coachLanguages", ctx_r142.coachLanguages)("textSessionCount", ctx_r142.textSessionCount)("session", ctx_r142.session)("visibleDialogBox", ctx_r142.visibleDialogBox)("pricingList", ctx_r142.pricingList)("userSessionCount", ctx_r142.userSessionCount)("isCoronaUser", ctx_r142.isCoronaUser)("sessionId", ctx_r142.sessionId)("sessionType", ctx_r142.sessionType);
} }
function ScheduleSessionComponent_div_36_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 129);
    i0.ɵɵtemplate(1, ScheduleSessionComponent_div_36_div_1_Template, 8, 14, "div", 130);
    i0.ɵɵelement(2, "div", 131);
    i0.ɵɵtemplate(3, ScheduleSessionComponent_div_36_payment_selection_3_Template, 1, 20, "payment-selection", 132);
    i0.ɵɵelement(4, "div", 133);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r13.momentDate);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r13.selectedUser && ctx_r13.confirmAttributes);
} }
function ScheduleSessionComponent_ng_template_37_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "session-scheduled-popup", 139);
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext();
    i0.ɵɵproperty("selectedUser", ctx_r15.selectedUser)("confirmAttributes", ctx_r15.confirmAttributes)("coachLanguages", ctx_r15.coachLanguages)("sessionType", ctx_r15.sessionType)("session", ctx_r15.session)("isCoach", ctx_r15.isCoach)("isCoronaUser", ctx_r15.isCoronaUser)("googleReminder", ctx_r15.googleReminder)("yahooReminder", ctx_r15.yahooReminder)("outlookReminder", ctx_r15.outlookReminder);
} }
function ScheduleSessionComponent_ng_template_39_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "modal-success", 140);
    i0.ɵɵpipe(1, "translate");
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext();
    i0.ɵɵproperty("titleText", "")("message", i0.ɵɵpipeBind1(1, 3, "sessionSchedule.dialog.alreadyFutureSessionMessage"))("navigateTo", ctx_r17.dialogAttributes.navigateTo);
} }
function ScheduleSessionComponent_ng_template_41_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 142);
    i0.ɵɵelement(1, "fa-icon", 143);
    i0.ɵɵelement(2, "div", 144);
    i0.ɵɵelementEnd();
} }
function ScheduleSessionComponent_ng_template_41_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ScheduleSessionComponent_ng_template_41_div_0_Template, 3, 0, "div", 141);
} if (rf & 2) {
    const ctx_r19 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r19.visibleDialogBox === "waitingForPaymentConfirmation");
} }
function ScheduleSessionComponent_ng_template_43_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "modal-success", 140);
    i0.ɵɵpipe(1, "translate");
} if (rf & 2) {
    i0.ɵɵproperty("titleText", "")("message", i0.ɵɵpipeBind1(1, 3, "Payment cancelled"))("navigateTo", "/session/schedule-session");
} }
function ScheduleSessionComponent_ng_template_45_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "modal-success", 140);
    i0.ɵɵpipe(1, "translate");
} if (rf & 2) {
    i0.ɵɵproperty("titleText", "Error")("message", i0.ɵɵpipeBind1(1, 3, "Payment cannot be verified"))("navigateTo", "/session/schedule-session");
} }
function ScheduleSessionComponent_ng_template_47_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "modal-success", 140);
    i0.ɵɵpipe(1, "translate");
} if (rf & 2) {
    i0.ɵɵproperty("titleText", "Payment status")("message", i0.ɵɵpipeBind1(1, 3, "Payment is being processed"))("navigateTo", "/index-user");
} }
function ScheduleSessionComponent_ng_template_49_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "modal-success", 140);
    i0.ɵɵpipe(1, "translate");
} if (rf & 2) {
    i0.ɵɵproperty("titleText", "")("message", i0.ɵɵpipeBind1(1, 3, "sessionSchedule.dialog.noCreditMessage"))("navigateTo", "user-voucher.html");
} }
function ScheduleSessionComponent_ng_template_51_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "modal-success", 140);
    i0.ɵɵpipe(1, "translate");
} if (rf & 2) {
    const ctx_r29 = i0.ɵɵnextContext();
    i0.ɵɵproperty("titleText", "")("message", i0.ɵɵpipeBind1(1, 3, "sessionSchedule.dialog.alreadyFutureSessionMessageForCoach"))("navigateTo", ctx_r29.dialogAttributes.navigateTo);
} }
const _c14 = function (a0) { return { username: a0 }; };
function ScheduleSessionComponent_ng_template_53_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "modal-success", 145);
    i0.ɵɵpipe(1, "translate");
} if (rf & 2) {
    const ctx_r31 = i0.ɵɵnextContext();
    i0.ɵɵproperty("titleText", "")("message", i0.ɵɵpipeBind2(1, 2, "sessionSchedule.dialog.noCreditMessageForCoach", i0.ɵɵpureFunction1(5, _c14, ctx_r31.selectedUser.login)));
} }
const _c15 = function () { return ["fas", "star"]; };
const _c16 = function () { return ["far", "star"]; };
function ScheduleSessionComponent_ng_template_55_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 146);
    i0.ɵɵelementStart(1, "span", 147);
    i0.ɵɵelementStart(2, "em", 148);
    i0.ɵɵelement(3, "fa-icon", 149);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "em", 150);
    i0.ɵɵelement(5, "fa-icon", 149);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const fill_r153 = ctx.fill;
    i0.ɵɵclassProp("full", fill_r153 === 100);
    i0.ɵɵadvance(1);
    i0.ɵɵstyleProp("width", fill_r153, "%");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("icon", i0.ɵɵpureFunction0(6, _c15));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("icon", i0.ɵɵpureFunction0(7, _c16));
} }
function ScheduleSessionComponent_ng_template_57_Template(rf, ctx) { if (rf & 1) {
    const _r156 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 151);
    i0.ɵɵelementStart(1, "fa-icon", 152);
    i0.ɵɵlistener("click", function ScheduleSessionComponent_ng_template_57_Template_fa_icon_click_1_listener() { i0.ɵɵrestoreView(_r156); const ctx_r155 = i0.ɵɵnextContext(); return ctx_r155.closeAll(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "div", 153);
    i0.ɵɵelement(3, "jhi-alert-error");
    i0.ɵɵelement(4, "coach-bio", 154);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r35 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("coach", ctx_r35.coachBioCoach);
} }
export const CURRENT_USER_ID = 0;
export class ScheduleSessionComponent extends BaseComponent {
    constructor(userService, userVoucherService, pricingService, sessionService, paymentService, accountService, sessionSettingService, route, router, eventManager, languageService, trackerService, elementRef, sessionStorage, modalService, calendarEventLinkService) {
        super(sessionStorage, modalService);
        this.userService = userService;
        this.userVoucherService = userVoucherService;
        this.pricingService = pricingService;
        this.sessionService = sessionService;
        this.paymentService = paymentService;
        this.accountService = accountService;
        this.sessionSettingService = sessionSettingService;
        this.route = route;
        this.router = router;
        this.eventManager = eventManager;
        this.languageService = languageService;
        this.trackerService = trackerService;
        this.elementRef = elementRef;
        this.sessionStorage = sessionStorage;
        this.modalService = modalService;
        this.calendarEventLinkService = calendarEventLinkService;
        this.onScheduleSession = new EventEmitter();
        this.onScheduleSessionText = new EventEmitter();
        this.onHourPressed = new EventEmitter();
        this.timezones = momenttz.tz.names();
        this.selectedTimezone = momenttz.tz.guess();
        this.today = moment();
        this.viewMode = "weekly";
        this.isScheduleSession = this.router.url.includes('/schedule-session');
        this.bookSessionStyle = { padding: '3rem!important', marginTop: '1.5rem!important' };
        this.coachLanguages = [];
        this.sessionType = 'text';
        this.isCoach = this.accountService.isCoach();
        this.isUser = this.accountService.isUser();
        this.isCoronaUser = false;
        this.headerWord = 'recommendChat';
        this.isVideo = false;
        this.selectedSessionTypes = ['text'];
        this.autoLookupTries = 0;
        this.maxAutoLookupTries = AvailableCoachSlotsCalendar.getDefaultAutoLookupTries(this.viewMode);
        this.maxAutoLookupTriesExtension = AvailableCoachSlotsCalendar.getMaxAutoLookupTriesExtension(this.viewMode);
        this.sessionTypeTab = "text";
        this.coachFilters = { searchQuery: '', psychologist: false, colleague: false };
        this.coachLabels = COACH_LABELS;
        this.getPaymentLogRetryCount = 0;
        this.selectedCoachIndex = -1;
        this.selectedSlotIndex = -1;
    }
    set sessionId(value) {
        this._sessionId = value;
        if (value) {
            this.isScheduled = 'update';
        }
        else {
            this.isScheduled = null;
        }
    }
    get sessionId() {
        return this._sessionId;
    }
    ngOnInit() {
        this.elementRef.nativeElement.ownerDocument.body.style.backgroundColor = '#F8F7F2';
        const previousSessionId = parseInt(this.route.snapshot.paramMap.get('previousSessionId'), 10);
        const sessionIdForReschedule = this.route.snapshot.paramMap.get('sessionId');
        if (this.route.snapshot.paramMap.get('sessionId')) {
            this.sessionId = parseInt(this.route.snapshot.paramMap.get('sessionId'), 10);
        }
        if (this.selectedUser) {
            this.renderComponent();
        }
        else if (previousSessionId) {
            this.sessionService.getSession(previousSessionId).subscribe(previousSession => {
                this.selectedUser = previousSession.body.user;
                this.currentCoach = previousSession.body.coach;
                // since the first and second (follow up) session might have different durations, we can't use the previous sessions' duration
                this.switchSessionTypeTab(previousSession.body.type);
                this.renderComponent();
            });
        }
        else if (sessionIdForReschedule) {
            this.sessionService.getSession(parseInt(sessionIdForReschedule, 10)).subscribe(sessionToReschedule => {
                this.selectedUser = sessionToReschedule.body.user;
                this.currentCoach = sessionToReschedule.body.coach;
                this.isReschedule = true;
                this.switchSessionTypeTab(sessionToReschedule.body.type, sessionToReschedule.body.duration);
                this.renderComponent();
            });
        }
        else {
            this.userService.current().subscribe(currentUser => {
                this.selectedUser = currentUser;
                this.renderComponent();
            });
        }
        this.sessionScheduledEventSubscription = this.eventManager.subscribe("sessionScheduled", (e) => {
            console.log("e: " + JSON.stringify(e));
            // this.displayOkDialog()
        });
        this.sessionListModificationEventSubscription = this.eventManager.subscribe("sessionListModification", () => { this.renderComponent(); });
        this.refreshAvailabilitiesRequestEventSubscription = this.eventManager.subscribe("refreshAvailabilities", () => {
            this.loadAvailableCoachSlots();
        });
    }
    ngOnChanges(changes) {
        this.renderComponent();
    }
    renderComponent() {
        this.langKey = this.languageService.getCurrentLanguage();
        this.futureSessionExists = false;
        const duration = this.route.snapshot.queryParams["duration"];
        if (duration) {
            this.duration = parseInt(duration.toString(), 10);
        }
        const sessionTypeQueryParam = this.route.snapshot.queryParams["sessionType"];
        if (sessionTypeQueryParam) {
            this.switchSessionTypeTab(sessionTypeQueryParam, this.duration);
        }
        let userId = this.route.snapshot.queryParams["userId"];
        let coachId = this.route.snapshot.queryParams["coachId"];
        this.matchWithCoachLanguages = this.route.snapshot.queryParams["sessionLanguage"];
        console.log("userId: " + userId + ", coachId: " + coachId);
        console.log(this.matchWithCoachLanguages);
        if (coachId) {
            this.currentCoach = new User(coachId);
            this.userService.findById(coachId).subscribe(c => {
                this.currentCoach = c;
            });
        }
        if (this.accountService.isCoach() && userId) {
            this.selectedUser = new User(userId);
            this.userService.findById(userId).subscribe(u => {
                this.selectedUser = u;
            });
        }
        this.userVoucherService.findList(this.selectedUser.id).subscribe((resList) => {
            console.log(resList.body);
            this.currentUserVouchers = resList.body || [];
            let currentUserVouchersExists = this.currentUserVouchers.length !== 0;
            let isCoronaVoucher = currentUserVouchersExists ? this.currentUserVouchers[this.currentUserVouchers.length - 1].voucher.code.toLowerCase() === 'connectforreal' : false;
            let firstUse = currentUserVouchersExists ? this.currentUserVouchers[this.currentUserVouchers.length - 1].numberOfSessionsLeft === this.currentUserVouchers[this.currentUserVouchers.length - 1].voucher.numberOfSessions : false;
            if (isCoronaVoucher && firstUse) {
                this.isCoronaUser = true;
            }
        });
        this.getSessionCounts(this.selectedUser.id);
        this.getSessionDuration(this.selectedUser.id);
        // this.userId = parseInt(this.route.snapshot.paramMap.get('userId'), 10);
        this.paymentId = this.route.snapshot.queryParams["paymentId"];
        if (this.paymentId) {
            this.getPaymentLog(this.paymentId);
        }
        else if (!this.sessionId) {
            this.sessionService.futureControl(this.selectedUser.id).subscribe(response => {
                if (response.body && response.body.length > 0) {
                    if (this.isUser)
                        this.dialogAttributes.navigateTo = window.location.href.endsWith("/inbox") ? "" : "/index-user";
                    else if (this.isCoach)
                        this.dialogAttributes.navigateTo = window.location.href.endsWith("/inbox") ? "" : "/index-coach";
                    this.open(this.alreadyFutureSessionDialog);
                }
            });
        }
        // this.code = "Enter your voucher code here";
        this.dialogAttributes = new DialogAttributes();
        // this.weekStart = moment().day(0);        // makes weekStart Sunday
        // this.weekStart = moment().isoWeekday(1); // makes weekStart Monday
        this.resetAvailablePeriodStartDay();
        this.loadAvailableCoachSlots();
        this.changeAttributes = new ChangeAttributes();
        this.changeAttributes.hid = true;
        console.log(this.changeAttributes);
        this.pricingService.productsAndPricesById(this.selectedUser.id).subscribe(map => {
            this.pricingList = map;
            if (!this.pricingList || this.pricingList.length === 0) {
                console.log("Error: no product found");
            }
            else {
                this.pricingList.sort((a, b) => a.numberOfCredits - b.numberOfCredits);
            }
        }, error => {
            console.log("Error: " + error);
        });
        this.paymentService.addCellulantSupport();
        if (!this.notEmbedded()) {
            if (this.accountService.isCoach()) {
                this.sessionService.creditControl(this.selectedUser.id).subscribe(credit => {
                    var _a, _b;
                    this.credit = credit;
                    if (this.futureSessionExists) {
                        this.onScheduleSessionText.emit('inukaNgApp.indexUser.alreadyBooked');
                    }
                    else if (((_a = this.credit) === null || _a === void 0 ? void 0 : _a.message) === 'noCreditForCoach') {
                        // this.open(this.noCreditForCoach);
                        this.onScheduleSessionText.emit('inukaNgApp.indexUser.noCredits');
                    }
                    else {
                        this.onScheduleSessionText.emit('inukaNgApp.indexUser.canBook');
                        console.log("credit: " + ((_b = this.credit) === null || _b === void 0 ? void 0 : _b.message));
                    }
                });
            }
        }
        else {
            console.log("checkUndefined");
        }
        // if(!this.langKeyChangedSubscription) {
        //   this.langKeyChangedSubscription = this.eventManager.subscribe('langKeyChanged', () => {
        //     // console.log("updating sessions");
        //     this.selectedDay = undefined; // reset selectedDate because there may not be available slot in the selected language
        //     this.displayWeek();
        //   });
        // }
        this.trackerService.sendActivity("book_screen_open");
    }
    resetAvailablePeriodStartDay() {
        if (this.viewMode === "weekly") {
            this.availablePeriodStart = AvailableCoachSlotsCalendar.getCurrentWeekStartingDay(this.selectedTimezone);
        }
        else if (this.viewMode === "monthly") {
            this.availablePeriodStart = AvailableCoachSlotsCalendar.getCurrentMonthStartingDay(this.selectedTimezone);
        }
    }
    getSessionDuration(userId) {
        if (this.currentCoach) {
            this.sessionSettingService.getSessionDurationByUserAndCoach(userId, this.currentCoach.id).subscribe(sessionDurationByType => {
                this.sessionDurationByType = sessionDurationByType.body;
                this.selectDefaultSessionDuration();
            });
        }
        else {
            this.sessionSettingService.getSessionDurationByUser(userId).subscribe(sessionDurationByType => {
                this.sessionDurationByType = sessionDurationByType.body;
                this.selectDefaultSessionDuration();
            });
        }
    }
    selectDefaultSessionDuration() {
        if (this.sessionDurationByType && this.sessionTypeTab) {
            const allowedDurations = this.sessionDurationByType[this.sessionTypeTab];
            if (allowedDurations === null || allowedDurations === void 0 ? void 0 : allowedDurations.length) {
                // if no duration is selected yet or the selected duration is not allowed (managers might have changed the session durations)
                if (!this.duration || allowedDurations.indexOf(this.duration) < 0) {
                    this.duration = allowedDurations[0];
                }
            }
        }
    }
    getSessionCounts(userId) {
        if (this.accountService.isUser()) {
            this.sessionService.getAllSessionsCountUserByUser().subscribe((res) => {
                console.log(res);
                this.userSessionCount = res;
            });
            this.sessionService.getAllTextSessionsCountUserByUser().subscribe((res) => {
                console.log(res);
                this.textSessionCount = res;
            });
        }
        else if (this.accountService.isCoach() || this.accountService.isCustomerCare()) {
            this.sessionService.getAllSessionsCountUserByCoach(userId).subscribe((res) => {
                console.log(res);
                this.userSessionCount = res;
            });
            this.sessionService.getAllTextSessionsCountUserByCoach(userId).subscribe((res) => {
                console.log(res);
                this.textSessionCount = res;
            });
        }
    }
    getPaymentLog(paymentId) {
        this.paymentService.getPaymentLog(paymentId).subscribe(res => {
            this.paymentAndSessionData = res.body;
            let paymentLog = this.paymentAndSessionData.payment;
            if (paymentLog.status === "COMPLETED" && paymentLog.sessionId) {
                this.session = this.paymentAndSessionData.session;
                let sessionStartTime = moment(this.paymentAndSessionData.session.sessionStartTime);
                this.createCalendarReminders(this.session);
                let coach = new User();
                coach.id = this.paymentAndSessionData.session.coachId;
                coach.login = this.paymentAndSessionData.coachName;
                this.confirmAttributes = new ConfirmAttributes(this.langKey, sessionStartTime, this.timeFormatted(sessionStartTime.tz(this.selectedTimezone)), coach);
                let coachId = this.confirmAttributes.coach.id;
                this.initializeLanguageOfSelectedCoach(coachId);
                this.displayOkDialog(this.paymentAndSessionData);
            }
            else if (paymentLog.status === "canceled") {
                // this.visibleDialogBox = "paymentIsCanceled";
                console.log("Payment cancelled");
                this.visibleDialogBox = "paymentCancelled";
                this.open(this.paymentCancelledDialogBox);
            }
            else {
                console.log("not scheduled yet: this.getPaymentLogRetryCount: " + this.getPaymentLogRetryCount);
                let executionCount = 10;
                if (this.getPaymentLogRetryCount === executionCount) {
                    this.visibleDialogBox = "";
                    this.closeAll();
                    if (paymentLog.status === "STARTED") {
                        this.open(this.paymentIsBeingProcessedDialogBox);
                    }
                    else {
                        this.open(this.paymentCannotBeVerifiedDialogBox);
                    }
                }
                else if (this.getPaymentLogRetryCount < executionCount) {
                    if (this.getPaymentLogRetryCount === 0) {
                        this.visibleDialogBox = "waitingForPaymentConfirmation";
                        this.open(this.dialogBox);
                    }
                    setTimeout(() => {
                        this.getPaymentLogRetryCount++;
                        this.getPaymentLog(paymentId);
                    }, 3000);
                }
            }
        }, error => {
            if (error.status === 404) {
                alert("Payment not found");
            }
            else {
                console.error("Payment error: " + JSON.stringify(error));
            }
        });
    }
    // https://outlook.office.com/calendar/0/deeplink/compose?allday=false&body=Nice%20description&startdt=2022-10-25T21%3A15%3A00%2B00%3A00&enddt=2022-10-25T21%3A45%3A00%2B00%3A00&subject=Your Inuka session&location=Inuka&path=%2Fcalendar%2Faction%2Fcompose&rru=addevent
    // https://outlook.office.com/owa/?path=/calendar/action/compose&rru=addevent&startdt=2021-05-24T12:00:00&enddt=2021-05-26T19:00:00&subject=Change This With A Subject &location=Change This With A Location&body=Change This With A Body Description.
    createCalendarReminders(session) {
        const calendarEventLinks = this.calendarEventLinkService.generateCalendarEventLinks(session);
        this.googleReminder = calendarEventLinks.google;
        this.outlookReminder = calendarEventLinks.outlook;
        this.yahooReminder = calendarEventLinks.yahoo;
    }
    displayOkDialog(paymentAndSessionData) {
        this.open(this.okDialog);
    }
    toLeft() {
        this.availablePeriodStart = this.availablePeriodStart.days(-6);
        this.loadAvailableCoachSlots();
    }
    toRight() {
        this.availablePeriodStart = this.availablePeriodStart.days(8);
        this.loadAvailableCoachSlots();
    }
    smoothScrollToElement(elementId) {
        const scrollToElement = window.setTimeout(() => {
            const pos = window.pageYOffset;
            const element = document.getElementById(elementId);
            if (elementId.includes('make-payment'))
                window.scrollTo(0, element.offsetTop - 532);
            else
                window.scrollTo(0, element.offsetTop);
        }, 100);
    }
    selectHour(hour, coachSlots, coachIndex, slotIndex, num, date) {
        this.momentDate = date;
        this.trackerService.sendActivity("book_select_time_btn_clicked");
        if (this.notEmbedded()) {
            if (num === 1)
                this.smoothScrollToElement("payment-selection-pc");
            else
                this.smoothScrollToElement("payment-selection-mobile");
        }
        else {
            this.smoothScrollToElementForCoach("payment-selection-mobile");
        }
        this.changeAttributes.hid = false;
        this.changeAttributes.voucherhid = true;
        this.selectedCoachIndex = coachIndex;
        this.selectedSlotIndex = slotIndex;
        this.confirmAttributes = new ConfirmAttributes(this.langKey, moment(date), hour, coachSlots.coach, date, this.duration);
        this.coachLanguages = this.matchWithCoachLanguages ? this.matchWithCoachLanguages : coachSlots.coachLanguages;
        this.videoChatEnabled = coachSlots.coachDetails.videoChatEnabled;
        this.textChatEnabled = coachSlots.coachDetails.textChatEnabled;
    }
    initializeLanguageOfSelectedCoach(coachId) {
        this.userService.getCoachReasoningLanguages(coachId).subscribe((res) => {
            this.coachLanguages = [];
            for (let i = 0; i < res.length; i++) {
                this.coachLanguages.push(LANGUAGES.find(l => l.code === res[i]).name);
            }
        });
    }
    smoothScrollToElementForCoach(elementId) {
        this.onHourPressed.emit(elementId);
    }
    loadAvailableCoachSlots() {
        var _a;
        if (!this.availablePeriodStart) {
            return;
        }
        this.confirmAttributes = null;
        this.langKey = this.languageService.getCurrentLanguage();
        if (this.availableSessionsObservable && !this.availableSessionsObservable.closed) {
            this.availableSessionsObservable.unsubscribe();
        }
        // console.log("displayWeek");
        let numberOfDays = 7;
        if (this.viewMode === "monthly") {
            numberOfDays = AvailableCoachSlotsCalendar.getTotalDaysInMonth(this.availablePeriodStart, this.selectedTimezone);
        }
        let request = {
            numberOfDays,
            dateTime: this.availablePeriodStart,
            userId: (_a = this.selectedUser) === null || _a === void 0 ? void 0 : _a.id,
            coachId: null,
            languages: this.selectedSessionLanguages,
            sessionTypes: this.selectedSessionTypes,
            duration: this.duration,
            coachFilters: this.coachFilters
        };
        if (this.currentCoach) {
            request.coachId = this.currentCoach.id;
        }
        console.log(request);
        const isAutoLookup = this.autoLookupTries > 0;
        this.availableSessionsObservable = this.sessionService.sessionAvailable(request, this.isScheduled, this.sessionId, isAutoLookup).subscribe(r => {
            var _a;
            if ((_a = r === null || r === void 0 ? void 0 : r.coachesSlots) === null || _a === void 0 ? void 0 : _a.length) {
                const availableCoachSlots = new AvailableCoachSlots(r);
                this.availableCoachSlotsCalendar = new AvailableCoachSlotsCalendar(availableCoachSlots, this.availablePeriodStart, this.viewMode, this.selectedTimezone);
                this.resetAutoLookupTries();
                // this.selectedDayAvailableCoachSlots = availableCoachSlots.days.find(d => moment(d.day).date() === moment(this.selectedDayAvailableCoachSlots.day).date());
            }
            else {
                this.availableCoachSlotsCalendar = new AvailableCoachSlotsCalendar(null, this.availablePeriodStart, this.viewMode, this.selectedTimezone);
                this.selectedDayAvailableCoachSlots = null;
                this.tryToLookupSlotInTheNextDays();
            }
        }, () => console.log("Error fetching sessionsAvailable() service"));
    }
    tryToLookupSlotInTheNextDays() {
        if (this.autoLookupTries < this.maxAutoLookupTries) {
            this.autoLookupTries++;
            this.showNextPeriod();
        }
        else {
            // max tries reached
            console.warn('I did my best to find an available slots :(');
        }
    }
    extendAutoLookupTries() {
        if (this.maxAutoLookupTries >= AvailableCoachSlotsCalendar.getMaxAutoLookupTriesExtension(this.viewMode)) {
        }
        this.maxAutoLookupTries = AvailableCoachSlotsCalendar.getMaxAutoLookupTriesExtension(this.viewMode);
        this.showNextPeriod();
    }
    resetAutoLookupTries() {
        this.autoLookupTries = 0;
        this.maxAutoLookupTries = AvailableCoachSlotsCalendar.getDefaultAutoLookupTries(this.viewMode);
    }
    open(content) {
        this.modalService.open(content, { ariaLabelledBy: "modal-basic-title", backdrop: "static", keyboard: false });
    }
    closeAll() {
        this.modalService.dismissAll();
    }
    close() {
        this.closeAll();
        this.smoothScrollUp();
        if (this.isScheduleSession)
            this.router.navigate(["/index-user"]).then();
    }
    smoothScrollUp() {
        const scrollToTop = window.setTimeout(() => {
            const pos = window.pageYOffset;
            window.scrollTo(0, 0); // how far to scroll on each step
        }, 1);
    }
    notEmbedded() {
        return !this.embedded();
    }
    embedded() {
        return this.mobile;
    }
    getCurrentCoachLogin() {
        return this.currentCoach.login;
    }
    currentCoachInitialized() {
        return this.currentCoach !== undefined;
    }
    hourOfDate(date) {
        return date.tz(this.selectedTimezone).format(!this.isAmPm ? "HH:mm" : "hh:mm a");
    }
    // TODO consider replacing this with ngClass
    setHourBackground(coachIndex, slotIndex) {
        var _a;
        // console.log("setHourBackground: coachIndex: " + coachIndex + ", isselected: " + this.changeAttributes.selectedCoachIndex + ", isselected2: " + this.changeAttributes.selectedSlotIndex + ", slotIndex: " + slotIndex);
        if (this.futureSessionExists) {
            return '#efefef';
        }
        else if (((_a = this.credit) === null || _a === void 0 ? void 0 : _a.message) === 'noCreditForCoach') {
            return '#efefef';
        }
        else if (!this.isSlotSelected(coachIndex, slotIndex)) {
            return '#FFFFFF';
        }
        else {
            return '';
        }
    }
    isSlotSelected(coachIndex, slotIndex) {
        return coachIndex === this.selectedCoachIndex && slotIndex === this.selectedSlotIndex;
    }
    //  THIS GETS THE SCHEDULED SESSION FROM PAYMENT SELECTION COMPONENT
    getScheduledSession(event) {
        console.log(event);
        this.onScheduleSession.emit(event);
        // this.renderComponent();
    }
    getSelectedTimezone(event) {
        this.selectedTimezone = event;
    }
    getAmPmChanged(event) {
        this.isAmPm = event;
    }
    ngOnDestroy() {
        if (this.langKeyChangedSubscription) {
            this.langKeyChangedSubscription.unsubscribe();
        }
        if (this.sessionScheduledEventSubscription) {
            this.sessionScheduledEventSubscription.unsubscribe();
        }
        if (this.sessionListModificationEventSubscription) {
            this.sessionListModificationEventSubscription.unsubscribe();
        }
        if (this.refreshAvailabilitiesRequestEventSubscription) {
            this.refreshAvailabilitiesRequestEventSubscription.unsubscribe();
        }
        if (this.availableSessionsObservable && !this.availableSessionsObservable.closed) {
            this.availableSessionsObservable.unsubscribe();
        }
    }
    toggleTimeFormatChange() {
        this.trackerService.sendActivity("book_changetimeformat_btn_clicked");
    }
    getSupportedLanguages(coachSlots) {
        let supportedLanguages = Array.from(coachSlots.coachReasoningByLang.keys());
        // console.log("supportedLanguages: " + supportedLanguages);
        return supportedLanguages;
    }
    onSelectedSessionTypesChanged(selectedSessionTypes) {
        var _a, _b;
        this.selectedSessionTypes = selectedSessionTypes;
        if (this.selectedSessionTypes.length === 0)
            this.selectedSessionTypes = ["text", "video"];
        if ((selectedSessionTypes === null || selectedSessionTypes === void 0 ? void 0 : selectedSessionTypes.length) === 1 && selectedSessionTypes[0] === 'video') {
            this.isVideo = true;
        }
        else {
            this.isVideo = false;
        }
        console.log(this.selectedSessionTypes);
        this.resetAvailablePeriodStartDay();
        this.loadAvailableCoachSlots();
        (_b = (_a = this.selectedDayAvailableCoachSlots) === null || _a === void 0 ? void 0 : _a.coachesSlots) === null || _b === void 0 ? void 0 : _b.filter((cs) => {
            if ((this.selectedSessionTypes.includes("text") && this.selectedSessionTypes.includes("video")) || selectedSessionTypes.length === 0) {
                cs.coachDetails.textChatEnabled === true || cs.coachDetails.videoChatEnabled === true;
            }
            else if (this.selectedSessionTypes.includes("text")) {
                cs.coachDetails.textChatEnabled === true;
            }
            else if (this.selectedSessionTypes.includes("video")) {
                cs.coachDetails.videoChatEnabled === false;
            }
        });
    }
    onSelectedSessionLanguagesChanged(selectedLanguages, ignoreLoadingAvailableCoachSlots) {
        var _a;
        if ((selectedLanguages === null || selectedLanguages === void 0 ? void 0 : selectedLanguages.toString()) !== ((_a = this.selectedSessionLanguages) === null || _a === void 0 ? void 0 : _a.toString())) {
            this.selectedSessionLanguages = selectedLanguages;
            if (!ignoreLoadingAvailableCoachSlots) {
                this.resetAvailablePeriodStartDay();
                this.loadAvailableCoachSlots();
            }
        }
    }
    onFocusOut() {
        this.coachFilters.searchQuery = this.searchText;
        this.resetAvailablePeriodStartDay();
        this.loadAvailableCoachSlots();
    }
    onKeyUp(event) {
        if (event != null) {
            if (event.code === 'Enter' || event.code === 'Escape') {
                this.coachFilters.searchQuery = this.searchText;
                this.resetAvailablePeriodStartDay();
                this.loadAvailableCoachSlots();
            }
        }
    }
    onLabelsSelected(selectedLabels) {
        this.selectedLabels = selectedLabels;
        this.coachLabels.forEach(l => {
            this.coachFilters[l.name] = this.selectedLabels.includes(l.name);
        });
        this.resetAvailablePeriodStartDay();
        this.loadAvailableCoachSlots();
    }
    onSelectedDayChange(dayAvailableCoachSlots) {
        var _a;
        if (this.selectedDayAvailableCoachSlots !== dayAvailableCoachSlots) {
            this.confirmAttributes = null;
            this.selectedDayAvailableCoachSlots = dayAvailableCoachSlots;
            // we don't need this anymore, the coach sorting happens on the backend
            // this.selectedDayAvailableCoachSlots.coachesSlots.sort((a, b) => {
            //   let orderA = a.coach.coachDisplayOrder;
            //   let orderB = b.coach.coachDisplayOrder;
            //   if (orderA === orderB) return 0.5 - Math.random();
            //   else return orderA - orderB;
            // });
            this.selectedCoachIndex = -1;
            this.selectedSlotIndex = -1;
            if (!((_a = dayAvailableCoachSlots.coachesSlots) === null || _a === void 0 ? void 0 : _a.length)) {
                this.selectedDayAvailableCoachSlots = undefined;
                return;
            }
            this.changeAttributes = new ChangeAttributes();
            this.trackerService.sendActivity("book_change_date_btn_clicked");
        }
    }
    showNextPeriod() {
        if (this.availableCoachSlotsCalendar.nextPeriodStaringDay) {
            this.availablePeriodStart = this.availableCoachSlotsCalendar.nextPeriodStaringDay;
            this.loadAvailableCoachSlots();
        }
    }
    showPreviousPeriod() {
        if (this.availableCoachSlotsCalendar.previousPeriodStaringDay) {
            this.availablePeriodStart = this.availableCoachSlotsCalendar.previousPeriodStaringDay;
            this.loadAvailableCoachSlots();
        }
    }
    changeViewMode(viewMode) {
        if (viewMode !== this.viewMode) {
            this.viewMode = viewMode;
            this.maxAutoLookupTries = AvailableCoachSlotsCalendar.getDefaultAutoLookupTries(this.viewMode);
            this.maxAutoLookupTriesExtension = AvailableCoachSlotsCalendar.getMaxAutoLookupTriesExtension(this.viewMode);
            this.resetAvailablePeriodStartDay();
            this.loadAvailableCoachSlots();
        }
    }
    showAllCoaches() {
        this.currentCoach = null;
        this.clearFilters();
    }
    clearFilters() {
        this.eventManager.broadcast("scheduleSessionFiltersCleared");
        this.switchSessionTypeTab('text');
        this.onSelectedSessionLanguagesChanged([], true);
        this.resetAutoLookupTries();
        this.resetAvailablePeriodStartDay();
        this.loadAvailableCoachSlots();
    }
    switchSessionTypeTab(selectedTab, duration) {
        if (this.sessionDurationByType && Object.keys(this.sessionDurationByType).indexOf(selectedTab) < 0) {
            this.openSessionTypeNotAllowedPopup();
            return;
        }
        this.sessionTypeTab = selectedTab;
        this.sessionType = selectedTab;
        if (duration) {
            this.duration = duration;
        }
        else {
            this.selectDefaultSessionDuration();
        }
        this.onSelectedSessionTypesChanged([this.sessionTypeTab]);
    }
    openSessionTypeNotAllowedPopup() {
        const modalRef = this.modalService.open(SessionTypeNotAllowedPopupComponent);
        modalRef.componentInstance.sessionType = this.sessionType;
        modalRef.componentInstance.duration = this.duration;
    }
    displayCoachBio(coach) {
        this.coachBioCoach = coach;
        this.modalService.open(this.coachBioModal, { size: 'lg', backdrop: 'static', centered: true });
    }
}
ScheduleSessionComponent.ɵfac = function ScheduleSessionComponent_Factory(t) { return new (t || ScheduleSessionComponent)(i0.ɵɵdirectiveInject(i1.UserService), i0.ɵɵdirectiveInject(i2.UserVoucherService), i0.ɵɵdirectiveInject(i3.PricingService), i0.ɵɵdirectiveInject(i4.SessionService), i0.ɵɵdirectiveInject(i5.PaymentService), i0.ɵɵdirectiveInject(i6.AccountService), i0.ɵɵdirectiveInject(i7.SessionSettingService), i0.ɵɵdirectiveInject(i8.ActivatedRoute), i0.ɵɵdirectiveInject(i8.Router), i0.ɵɵdirectiveInject(i9.JhiEventManager), i0.ɵɵdirectiveInject(i10.JhiLanguageService), i0.ɵɵdirectiveInject(i11.TrackerService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i12.SessionStorageService), i0.ɵɵdirectiveInject(i13.NgbModal), i0.ɵɵdirectiveInject(i14.CalendarEventLinkService)); };
ScheduleSessionComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ScheduleSessionComponent, selectors: [["schedule-session"]], viewQuery: function ScheduleSessionComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
        i0.ɵɵviewQuery(_c1, 5);
        i0.ɵɵviewQuery(_c2, 5);
        i0.ɵɵviewQuery(_c3, 5);
        i0.ɵɵviewQuery(_c4, 5);
        i0.ɵɵviewQuery(_c5, 5);
        i0.ɵɵviewQuery(_c6, 5);
        i0.ɵɵviewQuery(_c7, 5);
        i0.ɵɵviewQuery(_c8, 5);
        i0.ɵɵviewQuery(_c9, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.alreadyFutureSessionDialog = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.alreadyFutureSessionDialogForCoach = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.okDialog = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dialogBox = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.paymentCancelledDialogBox = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.paymentCannotBeVerifiedDialogBox = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.paymentIsBeingProcessedDialogBox = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.noCredit = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.noCreditForCoach = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.coachBioModal = _t.first);
    } }, inputs: { mobile: "mobile", selectedUser: "selectedUser", currentCoach: "currentCoach", sessionId: "sessionId" }, outputs: { onScheduleSession: "onScheduleSession", onScheduleSessionText: "onScheduleSessionText", onHourPressed: "onHourPressed" }, features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature], decls: 59, vars: 27, consts: [[1, "olha-theme", 3, "ngClass"], [1, "schedule-session"], [1, "flex-grow-1", 3, "ngClass"], [3, "ngClass"], [1, "pl-0", "pr-0", 3, "ngClass"], ["id", "payment-selection-mobile"], [3, "selectedUser", "selectedTimezone", "confirmAttributes", "changeAttributes", "videoChatEnabled", "textChatEnabled", "isCoach", "momentDate", "sessionCreateDTO", "isScheduled", "coachLanguages", "textSessionCount", "isCoronaUser", "session", "dialogAttributes", "visibleDialogBox", "pricingList", "userSessionCount", "sessionType", "sessionId", "onScheduleSession", "onMakePayment", 4, "ngIf"], ["id", "make-payment-mobile"], [3, "ngClass", 4, "ngIf"], [1, "row", "no-gutters"], [1, "col-md-12", "col-lg-12", 3, "ngClass"], [1, "row", "m-0"], [4, "ngIf"], [2, "padding", "24px"], [3, "selectedTimezone", "timezones", "onTimezoneSelected", "onAmPmChanged"], [1, "col-12", "mb-4", 3, "ngClass"], ["class", "row m-0", 4, "ngIf"], [1, "mx-4", "mt-3"], [1, "d-flex", "justify-content-between", "mb-4"], [1, "pt-3"], ["jhiTranslate", "sessionSchedule.header.bookYourSlot", 1, "font-weight-bold"], [1, "d-flex", "justify-content-end"], ["class", "col-12 my-5 text-center", 4, "ngIf"], ["class", "col-md-12 col-lg-12 d-none d-xl-block", "style", "height:400px", 4, "ngIf"], ["style", "height:320px", 4, "ngIf"], ["class", "text-center", 4, "ngIf"], ["class", "d-none d-xl-block col-lg-5 col-xl-4 confirmation-div payment-selection-pc", 4, "ngIf"], ["okDialog", ""], ["alreadyFutureSessionDialog", ""], ["dialogBox", ""], ["paymentCancelledDialogBox", ""], ["paymentCannotBeVerifiedDialogBox", ""], ["paymentIsBeingProcessedDialogBox", ""], ["noCredit", ""], ["alreadyFutureSessionDialogForCoach", ""], ["noCreditForCoach", ""], ["t", ""], ["coachBioModal", ""], [3, "selectedUser", "selectedTimezone", "confirmAttributes", "changeAttributes", "videoChatEnabled", "textChatEnabled", "isCoach", "momentDate", "sessionCreateDTO", "isScheduled", "coachLanguages", "textSessionCount", "isCoronaUser", "session", "dialogAttributes", "visibleDialogBox", "pricingList", "userSessionCount", "sessionType", "sessionId", "onScheduleSession", "onMakePayment"], ["showReasoning", "false", 3, "coachId", "selectedSessionType"], [1, "row", "justify-content-between", "mb-3"], [1, "col", "d-none", "d-lg-flex"], [3, "jhiTranslate", "translateValues", 4, "ngIf"], [1, "col", "text-right"], ["jhiTranslate", "sessionSchedule.button.weeklyViewMode", 1, "view-mode-switch", "mr-3", 3, "click"], ["jhiTranslate", "sessionSchedule.button.monthlyViewMode", 1, "view-mode-switch", 3, "click"], [1, "row"], [1, "col"], [3, "availableCoachSlotsCalendar", "viewMode", "selectedDateChange", "showNextPeriod", "showPreviousPeriod", 4, "ngIf"], [3, "jhiTranslate", "translateValues"], [3, "availableCoachSlotsCalendar", "viewMode", "selectedDateChange", "showNextPeriod", "showPreviousPeriod"], [1, "d-none", "d-lg-flex"], ["jhiTranslate", "sessionSchedule.header.findYourPerfectCoach", 4, "ngIf"], [1, "d-flex", "align-items-center", "filter-card"], [1, "material-design-filter"], ["appearance", "outline"], ["matInput", "", 3, "placeholder", "ngModel", "ngModelChange", "focusout", "keyup"], [3, "selectedLanguages", "onChange"], [3, "selectedLabels", "onLabelsSelected"], ["jhiTranslate", "sessionSchedule.header.findYourPerfectCoach"], [4, "ngFor", "ngForOf"], [1, "col", "p-1", "tab", "text-center", 3, "click"], ["style", "height: 14px; width: 14px; margin-right: 2px;", 4, "ngIf"], ["jhiTranslate", "inukaNgApp.session.type.text", 1, "mb-0", "text-center"], ["jhiTranslate", "sessionSchedule.paragraph.durationValue", 3, "translateValues"], [2, "height", "14px", "width", "14px", "margin-right", "2px"], [0, "xlink", "href", "../../../../../../../../content/images/sprite.svg?v=3#text-white"], [0, "xlink", "href", "../../../../../../../../content/images/sprite.svg?v=3#text-green"], ["style", "height: 14px; width: 14px; margin-right: 2px;margin-top: 4px;", 4, "ngIf"], ["jhiTranslate", "inukaNgApp.session.type.video", 1, "mb-0", "text-center"], [2, "height", "14px", "width", "14px", "margin-right", "2px", "margin-top", "4px"], [0, "xlink", "href", "../../../../../../../../content/images/sprite.svg?v=3#video-white"], [0, "xlink", "href", "../../../../../../../../content/images/sprite.svg?v=3#video-green"], [3, "id", 4, "ngFor", "ngForOf"], [3, "id"], ["class", "row my-2 px-3", "style", "cursor: pointer", 4, "ngIf"], ["class", "row", 4, "ngIf"], [1, "available-hours-mobile-2", "row", "mr-1", 2, "text-align", "center", 3, "id"], ["class", "col-4 col-sm-3 col-md-3", 4, "ngFor", "ngForOf"], [1, "row", "my-2", "px-3", 2, "cursor", "pointer"], [1, "col-2", "p-0", 3, "click"], [3, "coachLogin", "coachDetails"], [1, "col-10"], [1, "d-flex", "justify-content-start", "align-items-center", 3, "click"], [1, "coach-name", "text-nowrap", "m-0"], [1, "rating-star-score--2", 3, "click"], ["max", "5", 3, "rate", "starTemplate", "readonly", "rateChange"], [1, "px-2"], [1, "mt-2", 3, "click"], [3, "list"], [3, "coachDetails"], [1, "col-12", 2, "font-size", "0.975rem"], [3, "coachReasoningByLang"], [1, "col-4", "col-sm-3", "col-md-3"], [1, "text-nowrap", "mx-auto", "px-3", 3, "ngClass", "disabled", "ngStyle", "click"], [2, "color", "var(--border-color)"], [1, "col", "px-2", "py-3", "tab", "d-flex", "justify-content-center", "align-items-center", 3, "click"], [1, "d-flex", "justify-content-center", "align-items-center", "session-type"], [1, "mb-1"], ["class", "row no-gutters px-3", 4, "ngIf"], [1, "row", "no-gutters", "px-3"], ["class", "col-6", "style", "cursor: pointer", 3, "click", 4, "ngIf"], [1, "row", 3, "id"], ["class", "px-1", 3, "ngClass", 4, "ngFor", "ngForOf"], ["class", "col-12", 4, "ngIf"], [1, "col-6", 2, "cursor", "pointer", 3, "click"], [1, "row", "my-2"], [1, "col-2", "p-0"], [1, "col-10", "pr-0"], [1, "row", 2, "max-width", "300px"], [1, "col-12", "pr-0"], [1, "coach-name", "d-flex", "justify-content-start", "align-items-center", "float-left", "mr-2"], [1, "stars-outer"], [1, "row", "mt-2"], [1, "col-12"], [1, "row", "my-3"], [1, "px-1", 3, "ngClass"], [1, "btn-block", "hour-number", "text-nowrap", 3, "ngClass", "disabled", "ngStyle", "click"], [1, "col-12", "my-5", "text-center"], ["jhiTranslate", "sessionSchedule.paragraph.noCoachAvailable.title"], ["jhiTranslate", "sessionSchedule.paragraph.noCoachAvailable.text"], ["jhiTranslate", "sessionSchedule.paragraph.noCoachAvailable.extend", 1, "btn", "btn-secondary", 3, "click"], ["jhiTranslate", "sessionSchedule.paragraph.noCoachAvailableInNext6Month.title"], ["jhiTranslate", "sessionSchedule.paragraph.noCoachAvailableInNext6Month.text"], ["jhiTranslate", "sessionSchedule.paragraph.noCoachAvailableInNext6Month.clearFilters", 1, "btn", "btn-secondary", 3, "click"], [1, "col-md-12", "col-lg-12", "d-none", "d-xl-block", 2, "height", "400px"], [2, "height", "320px"], [1, "text-center"], ["jhiTranslate", "sessionSchedule.button.showAllCoaches", 1, "btn", "btn-link", 3, "click"], [1, "d-none", "d-xl-block", "col-lg-5", "col-xl-4", "confirmation-div", "payment-selection-pc"], ["class", "card card-borderless", 4, "ngIf"], ["id", "payment-selection-pc"], [3, "selectedUser", "confirmAttributes", "selectedTimezone", "changeAttributes", "sessionCreateDTO", "videoChatEnabled", "textChatEnabled", "isCoach", "momentDate", "isScheduled", "dialogAttributes", "coachLanguages", "textSessionCount", "session", "visibleDialogBox", "pricingList", "userSessionCount", "isCoronaUser", "sessionId", "sessionType", "onScheduleSession", "onMakePayment", 4, "ngIf"], ["id", "make-payment-pc"], [1, "card", "card-borderless"], [1, "card-body"], ["jhiTranslate", "sessionSchedule.paragraph.howToBook", 1, "font-weight-bold", "mb-4"], [3, "items"], [3, "selectedUser", "confirmAttributes", "selectedTimezone", "changeAttributes", "sessionCreateDTO", "videoChatEnabled", "textChatEnabled", "isCoach", "momentDate", "isScheduled", "dialogAttributes", "coachLanguages", "textSessionCount", "session", "visibleDialogBox", "pricingList", "userSessionCount", "isCoronaUser", "sessionId", "sessionType", "onScheduleSession", "onMakePayment"], [3, "selectedUser", "confirmAttributes", "coachLanguages", "sessionType", "session", "isCoach", "isCoronaUser", "googleReminder", "yahooReminder", "outlookReminder"], [3, "titleText", "message", "navigateTo"], ["class", "text-center m-4", 4, "ngIf"], [1, "text-center", "m-4"], ["icon", "spinner", "size", "3x", "spin", "true"], ["jhiTranslate", "sessionSchedule.dialog.paymentConfirmation", 1, "mt-2"], [3, "titleText", "message"], [1, "star"], [1, "half"], [2, "color", "#44A38D"], [3, "icon"], [1, "cursor", 2, "color", "#44A38D"], [1, "olha-theme", "p-4", "coach-bio"], ["icon", "times-circle", 1, "close", 3, "click"], [1, "main-body"], [3, "coach"]], template: function ScheduleSessionComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵelementStart(4, "div", 4);
        i0.ɵɵelement(5, "div", 5);
        i0.ɵɵtemplate(6, ScheduleSessionComponent_payment_selection_6_Template, 1, 20, "payment-selection", 6);
        i0.ɵɵelement(7, "div", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(8, ScheduleSessionComponent_div_8_Template, 2, 3, "div", 8);
        i0.ɵɵtemplate(9, ScheduleSessionComponent_div_9_Template, 11, 8, "div", 8);
        i0.ɵɵtemplate(10, ScheduleSessionComponent_div_10_Template, 16, 16, "div", 8);
        i0.ɵɵelementStart(11, "div", 3);
        i0.ɵɵelementStart(12, "div", 9);
        i0.ɵɵelementStart(13, "div", 10);
        i0.ɵɵelementStart(14, "div");
        i0.ɵɵelementStart(15, "div", 11);
        i0.ɵɵtemplate(16, ScheduleSessionComponent_ng_container_16_Template, 2, 1, "ng-container", 12);
        i0.ɵɵtemplate(17, ScheduleSessionComponent_ng_container_17_Template, 2, 1, "ng-container", 12);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(18, "div", 13);
        i0.ɵɵelementStart(19, "div");
        i0.ɵɵelementStart(20, "timezone-dropdown", 14);
        i0.ɵɵlistener("onTimezoneSelected", function ScheduleSessionComponent_Template_timezone_dropdown_onTimezoneSelected_20_listener($event) { return ctx.getSelectedTimezone($event); })("onAmPmChanged", function ScheduleSessionComponent_Template_timezone_dropdown_onAmPmChanged_20_listener($event) { return ctx.getAmPmChanged($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(21, ScheduleSessionComponent_ng_container_21_Template, 2, 1, "ng-container", 12);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(22, "div", 15);
        i0.ɵɵtemplate(23, ScheduleSessionComponent_div_23_Template, 3, 2, "div", 16);
        i0.ɵɵelementStart(24, "div", 17);
        i0.ɵɵelementStart(25, "div", 18);
        i0.ɵɵelementStart(26, "div", 19);
        i0.ɵɵelement(27, "h3", 20);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(28, "div", 21);
        i0.ɵɵelementStart(29, "div");
        i0.ɵɵelementStart(30, "timezone-dropdown", 14);
        i0.ɵɵlistener("onTimezoneSelected", function ScheduleSessionComponent_Template_timezone_dropdown_onTimezoneSelected_30_listener($event) { return ctx.getSelectedTimezone($event); })("onAmPmChanged", function ScheduleSessionComponent_Template_timezone_dropdown_onAmPmChanged_30_listener($event) { return ctx.getAmPmChanged($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(31, ScheduleSessionComponent_ng_container_31_Template, 2, 1, "ng-container", 12);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(32, ScheduleSessionComponent_div_32_Template, 3, 2, "div", 22);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(33, ScheduleSessionComponent_div_33_Template, 1, 0, "div", 23);
        i0.ɵɵtemplate(34, ScheduleSessionComponent_div_34_Template, 1, 0, "div", 24);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(35, ScheduleSessionComponent_div_35_Template, 3, 0, "div", 25);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(36, ScheduleSessionComponent_div_36_Template, 5, 2, "div", 26);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(37, ScheduleSessionComponent_ng_template_37_Template, 1, 10, "ng-template", null, 27, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(39, ScheduleSessionComponent_ng_template_39_Template, 2, 5, "ng-template", null, 28, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(41, ScheduleSessionComponent_ng_template_41_Template, 1, 1, "ng-template", null, 29, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(43, ScheduleSessionComponent_ng_template_43_Template, 2, 5, "ng-template", null, 30, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(45, ScheduleSessionComponent_ng_template_45_Template, 2, 5, "ng-template", null, 31, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(47, ScheduleSessionComponent_ng_template_47_Template, 2, 5, "ng-template", null, 32, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(49, ScheduleSessionComponent_ng_template_49_Template, 2, 5, "ng-template", null, 33, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(51, ScheduleSessionComponent_ng_template_51_Template, 2, 5, "ng-template", null, 34, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(53, ScheduleSessionComponent_ng_template_53_Template, 2, 7, "ng-template", null, 35, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(55, ScheduleSessionComponent_ng_template_55_Template, 6, 8, "ng-template", null, 36, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(57, ScheduleSessionComponent_ng_template_57_Template, 5, 1, "ng-template", null, 37, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", ctx.notEmbedded() ? "container" : "css1");
        i0.ɵɵadvance(2);
        i0.ɵɵstyleMap(ctx.bookSessionStyle);
        i0.ɵɵproperty("ngClass", ctx.notEmbedded() ? "row mx-0" : "css2");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", ctx.notEmbedded() ? "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-8" : "col-12");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", ctx.notEmbedded() ? "col-md-12 col-lg-12 d-xl-none payment-selection-mobile" : "col-lg-12 col-xl-12 confirmation-div payment-selection-mobile");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.selectedUser && ctx.confirmAttributes);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.currentCoach);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.availableCoachSlotsCalendar == null ? null : ctx.availableCoachSlotsCalendar.hasAnyAvailableSlot);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.availableCoachSlotsCalendar == null ? null : ctx.availableCoachSlotsCalendar.hasAnyAvailableSlot) && !ctx.isReschedule && !ctx.currentCoach);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", ctx.notEmbedded() ? "card card-borderless" : "");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", ctx.notEmbedded() ? "d-xl-none" : "d-xl-block");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.sessionDurationByType == null ? null : ctx.sessionDurationByType.text);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.sessionDurationByType == null ? null : ctx.sessionDurationByType.video);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("selectedTimezone", ctx.selectedTimezone)("timezones", ctx.timezones);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.selectedDayAvailableCoachSlots);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", ctx.notEmbedded() ? "d-none d-xl-block" : "d-none");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.sessionType == "text" || ctx.sessionType == "video");
        i0.ɵɵadvance(7);
        i0.ɵɵproperty("selectedTimezone", ctx.selectedTimezone)("timezones", ctx.timezones);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.selectedDayAvailableCoachSlots);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.autoLookupTries === ctx.maxAutoLookupTries);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.notEmbedded());
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.notEmbedded() && ctx.changeAttributes.hid && ctx.isScheduleSession);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.currentCoach && ctx.isUser && !ctx.isReschedule);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.notEmbedded());
    } }, directives: [i15.NgClass, i15.NgIf, i16.TimezoneDropdownComponent, i17.JhiTranslateDirective, i18.PaymentSelectionComponent, i19.CoachInfoComponent, i20.AvailableCoachSlotsCalendarComponent, i21.MatFormField, i21.MatLabel, i22.MatInput, i23.DefaultValueAccessor, i23.NgControlStatus, i23.NgModel, i24.SessionLanguageSelectorComponent, i25.LabelSelectorComponent, i15.NgForOf, i26.CoachProfileImageComponent, i13.NgbRating, i27.SupportedLanguagesComponent, i28.BadgeComponent, i29.CoachReasoningComponent, i15.NgStyle, i30.StepperComponent, i31.SessionScheduledPopupComponent, i32.ModalSuccessComponent, i33.FaIconComponent, i34.AlertErrorComponent, i35.CoachBioComponent], pipes: [i36.TranslatePipe, i15.DecimalPipe], styles: [".container[_ngcontent-%COMP%]{padding-top:90px;max-width:1400px !important}.coach-bio[_ngcontent-%COMP%]{min-height:600px;max-height:800px}coach-bio[_ngcontent-%COMP%]{overflow:scroll}h4[_ngcontent-%COMP%]{font-size:1.5rem}td[_ngcontent-%COMP%]:after{content:\"\";display:block;margin-top:10%;margin-bottom:10%}td.content[_ngcontent-%COMP%]{position:absolute;top:50%;bottom:0;left:0;right:0}table.calendar[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{width:9%;border-spacing:10px;position:relative}button[_ngcontent-%COMP%]:active{outline:none;border:none}button[_ngcontent-%COMP%]:focus{outline:0}.hour-number[_ngcontent-%COMP%]{background-color:#fff;border-radius:.3rem;outline:none;border:1px solid var(--main);color:var(--main);display:block;margin:.5rem;text-align:center;padding-top:.4rem;padding-bottom:.4rem}.hour-number-selected[_ngcontent-%COMP%]{background-color:var(--main);border:none;color:#fff}.day-number[_ngcontent-%COMP%]{border-radius:50%;border:0 none;background-color:#fff;color:#000;text-align:center;width:auto !important;display:block;margin:0 auto;padding-right:.3rem;padding-left:.3rem}.day-number-2[_ngcontent-%COMP%]{color:#000;font-weight:bold;margin:13px auto 20px auto}.day-number-selected[_ngcontent-%COMP%]{background-color:var(--primary-color);color:#fff}.dayNumberEffect[_ngcontent-%COMP%]{border-radius:50%;border:0;color:#000;font-weight:bold;text-align:center;width:auto !important;display:block;margin:20px auto;opacity:1}.title[_ngcontent-%COMP%]{display:block;position:relative;max-width:100%;margin:0 0 .4em;padding:0;color:#595959;font-size:1.875em;font-weight:600;text-align:center !important;text-transform:none;word-wrap:break-word}.content[_ngcontent-%COMP%]{justify-content:center;margin:0;padding:0;color:#545454;font-size:1.125em;font-weight:300;line-height:normal;z-index:1;word-wrap:break-word;text-align:center}.star[_ngcontent-%COMP%]{position:relative;display:inline-block;font-size:1rem}.half[_ngcontent-%COMP%]{position:absolute;display:inline-block;overflow:hidden}.text-warning[_ngcontent-%COMP%]{color:#008b8b !important}.card[_ngcontent-%COMP%]{margin-bottom:1rem !important}.css1[_ngcontent-%COMP%]{position:absolute;right:0;left:0;display:flex;flex-direction:column}.css2[_ngcontent-%COMP%]{overflow-y:scroll;overflow-x:hidden;scroll-behavior:smooth}.scroll-icon[_ngcontent-%COMP%]{font-size:30px;cursor:pointer}.slide-toggle-label[_ngcontent-%COMP%]{font-family:Roboto,\"Helvetica Neue\",sans-serif;font-size:10px;font-weight:400;line-height:16px;color:rgba(0,0,0,.54)}[_nghost-%COMP%]     .mat-slide-toggle.mat-checked:not(.mat-disabled) .mat-slide-toggle-bar{background:#44a38d}[_nghost-%COMP%]     .mat-slide-toggle.mat-checked:not(.mat-disabled) .mat-slide-toggle-thumb{background:#fff}[_nghost-%COMP%]     .mat-slide-toggle .mat-slide-toggle-bar{background-color:#e1e1e1}[_nghost-%COMP%]     .mat-slide-toggle .mat-slide-toggle-thumb{background-color:#fff}[_nghost-%COMP%]  .mat-form-field-label{font-size:13.5px !important}[_nghost-%COMP%]  .mat-select-placeholder{color:var(--text) !important}.tab[_ngcontent-%COMP%]{cursor:pointer;border:1px solid var(--main);border-right:0;color:var(--main)}.tab[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{color:var(--main)}.tab[_ngcontent-%COMP%]:first-of-type{border-top-left-radius:20px}.tab[_ngcontent-%COMP%]:last-of-type{border-top-right-radius:20px;border-right:1px solid var(--main)}.selected-tab[_ngcontent-%COMP%]{background-color:var(--main);color:#fff !important}.selected-tab[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{color:#fff !important}.video-call-option[_ngcontent-%COMP%]{border-radius:1rem;background-color:rgba(68,163,141,.1);color:var(--primary-color)}.coach-name[_ngcontent-%COMP%]{font-size:18px;font-weight:600;font-family:var(--headers-font-family);height:33px}.view-mode-switch[_ngcontent-%COMP%]{background:transparent;border:1px solid #cce9e0;border-radius:10px;color:#0a4a3a;padding:.4rem 1.3rem}.view-mode-switch-selected[_ngcontent-%COMP%]{border:1px solid #44a38b;background:#44a38b;color:#fff}.stars-outer[_ngcontent-%COMP%]{padding-left:15px}.badge[_ngcontent-%COMP%]{background:rgba(68,163,141,.1);color:#44a38b;border-radius:16px;padding:1px 20px;width:120px;height:30px;margin-left:10px}.filter-card[_ngcontent-%COMP%]{flex-direction:row;justify-content:space-between !important}.session-type[_ngcontent-%COMP%]{flex-direction:row}.material-design-filter[_ngcontent-%COMP%]{flex:1;margin-right:10px;width:100%}@media(max-width: 360px){.container[_ngcontent-%COMP%]{padding-right:0;padding-left:0}}@media(max-width: 768px){.filter-card[_ngcontent-%COMP%]{flex-direction:column;justify-content:flex-start !important}}@media(max-width: 1350px){.session-type[_ngcontent-%COMP%]{flex-direction:column}}"] });
